import React from "react";
import "./FooterBar.css";
import { AppContextType, HelpPageName } from "../../AppContext";

interface Props {}

export default class FooterBar extends React.Component<Props> {
  declare context: React.ContextType<typeof AppContextType>;
  handleOpenTos = () => {
    this.context.dispatch({ type: "ShowHelpPage", payload: HelpPageName.TermsOfService });
  };
  render() {
    return (
      <footer className="footer-bar">
        <small>© Curtis Kisielius 2025</small>
        {" -- "}
        <small>
          <button className="terms-of-service-link" onClick={this.handleOpenTos}>
            Terms of Service
          </button>
        </small>
      </footer>
    );
  }
}

FooterBar.contextType = AppContextType;
